export default __webpack_public_path__ + "static/media/CardImg1.7136c177.jpg";